// Generated by purs version 0.14.3
"use strict";
var App_Model = require("../App.Model/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Data_Function = require("../Data.Function/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Web_HTML_Common = require("../Web.HTML.Common/index.js");
var LoadFailed = (function () {
    function LoadFailed() {

    };
    LoadFailed.value = new LoadFailed();
    return LoadFailed;
})();
var LoadSucceeded = (function () {
    function LoadSucceeded() {

    };
    LoadSucceeded.value = new LoadSucceeded();
    return LoadSucceeded;
})();
var RetryLoading = (function () {
    function RetryLoading() {

    };
    RetryLoading.value = new RetryLoading();
    return RetryLoading;
})();
var imageComponent = function (dictMonadAff) {
    return function (initialState) {
        var render = function (img) {
            var renderImage = function (i) {
                return Halogen_HTML_Elements.img([ Halogen_HTML_Properties.class_("Image-img"), Halogen_HTML_Properties.src(i.baseURL), Halogen_HTML_Events.onError(Data_Function["const"](LoadFailed.value)), Halogen_HTML_Events.onLoad(Data_Function["const"](LoadSucceeded.value)) ]);
            };
            var classNameModifiers = (function () {
                if (img.loadStatus instanceof App_Model.Loading) {
                    return "Image--loading";
                };
                if (img.loadStatus instanceof App_Model.Loaded) {
                    return "Image--loaded";
                };
                if (img.loadStatus instanceof App_Model.Failed) {
                    return "Image--failed";
                };
                throw new Error("Failed pattern match at App.Component.Image (line 50, column 28 - line 53, column 34): " + [ img.loadStatus.constructor.name ]);
            })();
            return Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_(Web_HTML_Common.ClassName("Image " + classNameModifiers)) ])((function () {
                if (img.loadStatus instanceof App_Model.Loading) {
                    return [ renderImage(img) ];
                };
                if (img.loadStatus instanceof App_Model.Loaded) {
                    return [ renderImage(img) ];
                };
                if (img.loadStatus instanceof App_Model.Failed) {
                    return [ Halogen_HTML_Elements.div([ Halogen_HTML_Properties.class_("Image-error"), Halogen_HTML_Events.onClick(Data_Function["const"](RetryLoading.value)) ])([  ]) ];
                };
                throw new Error("Failed pattern match at App.Component.Image (line 64, column 11 - line 73, column 16): " + [ img.loadStatus.constructor.name ]);
            })());
        };
        var $$eval = (function () {
            var handleAction = function (v) {
                if (v instanceof LoadFailed) {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                        var $9 = st.loadTryCount > 0;
                        if ($9) {
                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff.delay(1000.0)))(function () {
                                return Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                                    var $10 = {};
                                    for (var $11 in st) {
                                        if ({}.hasOwnProperty.call(st, $11)) {
                                            $10[$11] = st[$11];
                                        };
                                    };
                                    $10.loadTryCount = st.loadTryCount - 1 | 0;
                                    return $10;
                                })());
                            });
                        };
                        return Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)((function () {
                            var $13 = {};
                            for (var $14 in st) {
                                if ({}.hasOwnProperty.call(st, $14)) {
                                    $13[$14] = st[$14];
                                };
                            };
                            $13.loadStatus = App_Model.Failed.value;
                            return $13;
                        })());
                    });
                };
                if (v instanceof LoadSucceeded) {
                    return Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                        var $16 = {};
                        for (var $17 in v1) {
                            if ({}.hasOwnProperty.call(v1, $17)) {
                                $16[$17] = v1[$17];
                            };
                        };
                        $16.loadStatus = App_Model.Loaded.value;
                        return $16;
                    });
                };
                if (v instanceof RetryLoading) {
                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                        return Control_Monad_State_Class.put(Halogen_Query_HalogenM.monadStateHalogenM)(App_Model.initialImage(st.baseURL));
                    });
                };
                throw new Error("Failed pattern match at App.Component.Image (line 85, column 5 - line 85, column 75): " + [ v.constructor.name ]);
            };
            return Halogen_Component.mkEval({
                handleAction: handleAction,
                handleQuery: Halogen_Component.defaultEval.handleQuery,
                receive: Halogen_Component.defaultEval.receive,
                initialize: Halogen_Component.defaultEval.initialize,
                finalize: Halogen_Component.defaultEval.finalize
            });
        })();
        return Halogen_Component.mkComponent({
            initialState: Data_Function["const"](initialState),
            render: render,
            "eval": $$eval
        });
    };
};
module.exports = {
    LoadFailed: LoadFailed,
    LoadSucceeded: LoadSucceeded,
    RetryLoading: RetryLoading,
    imageComponent: imageComponent
};
